import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined);

    useEffect(() => {
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(null));
    }, []);

    const login = useCallback(async (email, password) => {
        const r = await api.post("/auth/login", { email, password });
        setUser(r.data);
        return r.data;
    }, []);

    const logout = useCallback(async () => {
        try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
